import { render, staticRenderFns } from "./Ads.vue?vue&type=template&id=5f4c0069&"
import script from "./Ads.vue?vue&type=script&lang=js&"
export * from "./Ads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VChip,VDataTable,VIcon,VPagination,VSwitch})
